<template>
  <div class="blog-list">
    <div v-if="!page.loading">
      <!--<div class="page-headline container is-boxed-fluid">-->
        <!--<ul class="breadcrumbs">-->
          <!--<li>-->
            <!--<router-link :to="{name: 'home'}">Homepage</router-link>-->
          <!--</li>-->
          <!--<li>-->
            <!--<router-link :to="{name: 'shop'}">L'blog</router-link>-->
          <!--</li>-->
        <!--</ul>-->
      <!--</div>-->
      <div class="container is-boxed-fluid">
        <div class="row">
          <div class="col-9 col-xs-12">
            <div class="row">
              <blog-item class="col-6" v-for="(item, key) in page.data.posts" :key="key" :item="item"></blog-item>
            </div>
          </div>
          <div class="col-3 col-xs-12">
            <div class="blog-widget">
              <subscribe-widget></subscribe-widget>
              <product-widget :products="page.data.products"></product-widget>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="blog-loading" v-if="page.loading">
      <div class="container is-boxed-fluid">
        <div class="row">
          <div class="col col-xs-12">
            <div class="loading"></div>
          </div>
          <div class="col col-xs-12">
            <ul>
              <li class="loading"></li>
              <li class="loading"></li>
              <li class="loading"></li>
              <li class="loading"></li>
            </ul>
          </div>
        </div>
        <div class="row">
          <div class="col col-xs-12">
            <ul>
              <li class="loading"></li>
              <li class="loading"></li>
              <li class="loading"></li>
              <li class="loading"></li>
            </ul>
          </div>
          <div class="col col-xs-12">
            <div class="loading"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BlogItem from '@/components/items/Blog.vue'
import SubscribeWidget from '@/components/blog/Subscribe.vue';
import ProductWidget from '@/components/blog/ProductWidget.vue';
export default {
  name: 'blog',
  components: {
    BlogItem,
    SubscribeWidget,
    ProductWidget
  },
  data () {
    return {
      title: 'L’editorial',
      blog: [
        {
          subtitle: 'Lifestyle',
          title:
            'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
          description:
            'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout ...',
          date: 'September4, 2019',
          image: '/img/editorial-1.png',
          slug: 'editorial'
        },
        {
          subtitle: 'Lifestyle',
          title:
            'Contrary to popular belief, Lorem Ipsum is not simply random text.',
          description:
            'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout ...',
          date: 'September4, 2019',
          image: '/img/editorial-2.png',
          slug: 'editorial'
        },
        {
          subtitle: 'Lifestyle',
          title:
            'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
          description:
            'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout ...',
          date: 'September4, 2019',
          image: '/img/editorial-1.png',
          slug: 'editorial'
        },
        {
          subtitle: 'Lifestyle',
          title:
            'Contrary to popular belief, Lorem Ipsum is not simply random text.',
          description:
            'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout ...',
          date: 'September4, 2019',
          image: '/img/editorial-2.png',
          slug: 'editorial'
        },
        {
          subtitle: 'Lifestyle',
          title:
            'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
          description:
            'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout ...',
          date: 'September4, 2019',
          image: '/img/editorial-1.png',
          slug: 'editorial'
        },
        {
          subtitle: 'Lifestyle',
          title:
            'Contrary to popular belief, Lorem Ipsum is not simply random text.',
          description:
            'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout ...',
          date: 'September4, 2019',
          image: '/img/editorial-2.png',
          slug: 'editorial'
        }
      ]
    }
  },
  computed: mapState(['page'])
}
</script>

<style lang="scss">
.blog-list {
  padding-top: 130px;

  @include mq($ms){
    padding-top: 90px;
  }

  @include mq($ms) {
    .editorial-info{
      padding: 15px 0!important;
    }
    .editorial-image {
      margin-left: -15px;
      margin-right: -15px;
    }
  }

  .blog-loading {
    .loading {
      animation: gradient 0.7s infinite;
    }
    div.loading {
      height: 500px;
    }
    ul {
      padding-top: 50px;
      li.loading {
        height: 20px;
        margin-bottom: 15px;
        &:nth-child(1) {
          width: 50%;
        }
        &:nth-child(2) {
          width: 80%;
        }
        &:nth-child(3) {
          width: 70%;
        }
        &:nth-child(4) {
          width: 60%;
        }
      }
    }
  }
}
</style>
